import {
  Cancel, // ícone para 'Cancelled'
  CheckCircle, // ícone para 'Confirmed' e 'Delivered'
  ErrorOutline, // ícone para 'Error'
  HourglassEmpty, // ícone para 'Waiting'
  Inventory, // ícone para 'Handling'
  LocalShipping, // ícone para 'Shipped'
  Notifications,
} from "@mui/icons-material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaidIcon from "@mui/icons-material/Paid";
import PixIcon from "@mui/icons-material/Pix";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { OrderDetailsMessages } from "@/messages/order-details/order-details.messages";
import { OrderItemListMessages } from "@/messages/order-details/order-Item-list.messages";
import { OrderTrackingMessages } from "@/messages/order-details/order-tracking.messages";
import { TabItem } from "@/types/form.types";
import { OrderStatus } from "@/types/order.types";

import { OrderDetailsTabs } from "./types";

export const ITEMS_TABLE_COLUMNS = (
  messages: OrderItemListMessages,
  showCommentColumn: boolean = false
) => {
  const columns = [messages.itemSkuLabel, messages.itemProductLabel];

  if (showCommentColumn) {
    columns.push(messages.itemCommentLabel);
  }

  columns.push(messages.itemQuantityLabel, messages.itemPriceLabel, messages.itemTotalLabel);

  return columns;
};

export const statusToLabelMap: { [key in OrderStatus]: keyof OrderTrackingMessages } = {
  [OrderStatus.Confirmed]: "orderReceivedLabel", // Aguardando Pagamento (inverter com Orçamento)
  [OrderStatus.Paid]: "orderPaidLabel", // Pago
  [OrderStatus.Handling]: "orderHandlingLabel", // Em manuseio
  [OrderStatus.Invoiced]: "orderInvoicedLabel", // Faturado
  [OrderStatus.Shipped]: "orderShippedLabel", // Enviado
  [OrderStatus.Delivered]: "orderDeliveredLabel", // Entregue
  [OrderStatus.Cancelled]: "orderCancelledLabel", // Cancelado
  [OrderStatus.Waiting]: "orderWaitingLabel", // Orçamento (inverter com Aguardando Pagamento)
  [OrderStatus.Error]: "orderErrorLabel", // Erro
  [OrderStatus.CancellationRequest]: "orderCancellationRequestLabel", // Pedido de Cancelamento
};

export const statusToIconMap: { [key in OrderStatus]: React.ElementType } = {
  [OrderStatus.Confirmed]: HourglassEmpty, // Aguardando Pagamento (inverter com Orçamento)
  [OrderStatus.Paid]: PaidIcon, // Pago
  [OrderStatus.Handling]: Inventory, // Em manuseio
  [OrderStatus.Invoiced]: ShoppingCartIcon, // Faturado
  [OrderStatus.Shipped]: LocalShipping, // Enviado
  [OrderStatus.Delivered]: CheckCircle, // Entregue
  [OrderStatus.Cancelled]: Cancel, // Cancelado
  [OrderStatus.Waiting]: Notifications, // Orçamento (inverter com Aguardando Pagamento)
  [OrderStatus.Error]: ErrorOutline, // Erro
  [OrderStatus.CancellationRequest]: Cancel, // Pedido de Cancelamento
};

export const paymentIcons: {
  [key: string]: typeof CreditCardIcon | typeof PixIcon | typeof ReceiptIcon;
} = {
  CARTÃO: CreditCardIcon,
  PIX: PixIcon,
  BOLETO: ReceiptIcon,
};

export const TABS_ITEMS = (messages: OrderDetailsMessages): TabItem<OrderDetailsTabs>[] => {
  const { orderDetailsSection, chatSection } = messages;
  const tabs = [
    { value: "orderDetailsTab", label: orderDetailsSection },
    { value: "chatTab", label: chatSection },
  ];

  return tabs as TabItem<OrderDetailsTabs>[];
};
